(function () {
  'use strict';

  if (window.gmReviewSchemaConsolidationInitialized) return;
  window.gmReviewSchemaConsolidationInitialized = true;

  function productNode(value) {
    if (!value || typeof value !== 'object') return null;

    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i += 1) {
        var arrayProduct = productNode(value[i]);
        if (arrayProduct) return arrayProduct;
      }
      return null;
    }

    var type = value['@type'];
    var isProduct = type === 'Product' || (Array.isArray(type) && type.indexOf('Product') !== -1);
    if (isProduct && value.description && value.brand && value.offers) return value;

    if (value['@graph']) return productNode(value['@graph']);
    return null;
  }

  function validAggregateRating(value) {
    if (!value || typeof value !== 'object') return false;
    var type = value['@type'];
    var ratingValue = Number(value.ratingValue);
    var reviewCount = Number(value.reviewCount || value.ratingCount);
    return type === 'AggregateRating' && Number.isFinite(ratingValue) && ratingValue > 0 &&
      Number.isFinite(reviewCount) && reviewCount > 0;
  }

  function consolidateReviewSchema() {
    var duplicateScripts = Array.prototype.slice.call(
      document.querySelectorAll('script.y-rich-snippet-script[type="application/ld+json"]')
    );
    if (!duplicateScripts.length) return false;

    var primaryScript = null;
    var primaryData = null;
    var primaryProduct = null;

    Array.prototype.slice.call(
      document.querySelectorAll('script[type="application/ld+json"]:not(.y-rich-snippet-script)')
    ).some(function (script) {
      try {
        var data = JSON.parse(script.textContent || '{}');
        var product = productNode(data);
        if (!product) return false;
        primaryScript = script;
        primaryData = data;
        primaryProduct = product;
        return true;
      } catch (error) {
        return false;
      }
    });

    if (!primaryScript || !primaryProduct) return false;

    var aggregateRating = null;
    duplicateScripts.some(function (script) {
      try {
        var data = JSON.parse(script.textContent || '{}');
        var type = data['@type'];
        var isProduct = type === 'Product' || (Array.isArray(type) && type.indexOf('Product') !== -1);
        if (!isProduct || !validAggregateRating(data.aggregateRating)) return false;
        aggregateRating = data.aggregateRating;
        return true;
      } catch (error) {
        return false;
      }
    });

    if (aggregateRating) primaryProduct.aggregateRating = aggregateRating;
    primaryScript.textContent = JSON.stringify(primaryData);
    duplicateScripts.forEach(function (script) { script.remove(); });
    return true;
  }

  var observer = new MutationObserver(consolidateReviewSchema);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', consolidateReviewSchema, { once: true });
  } else {
    consolidateReviewSchema();
  }
  window.addEventListener('load', consolidateReviewSchema, { once: true });
})();